import React, {useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonButtons, IonButton, IonMenuButton, IonModal, IonLabel, IonFooter} from '@ionic/react';
import { IonGrid, IonRow, IonCol, IonInput } from '@ionic/react';
import { Browser } from '@capacitor/browser';


import '../../css/layout.css';
import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';
import { ViewPaySlipModal } from './Modal_ViewPaySlip';

import {v4 as uuid} from 'uuid';

export function ProfileSetting_EmployeePayInfo (props) {

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID ] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);

    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewPaychecks, setViewPaychecks] = useState([]);

    let [disableApprovePayButton, setDisableApprovePayButton] = useState(false);
    let [showPayslipModal, setShowPayslipModal] = useState(false);   

    let [pay_id, setPayID] = useState('');
    let [employeeName, setEmployeeName] = useState('NO PAYCHECKS');
    let [paySlipAttachment, setPaySlipAttachment] = useState('');

    useEffect(() => {



        if(props.openModal == true)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74800_view_payStubs',
                    user: acctID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'zsava_internal_indexApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    if(rownum == 0)
                    {
                        setEmployeeName(cols[1]);
                    }

                    setViewPaychecks((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            employeeID: cols[0],
                            employeeName: cols[1],
                            stub_ammount:parseFloat(cols[2]).toFixed(2),
                            stub_date: cols[3],
                            pay_slip: cols[4],
                            status: cols[5],
                            momo_number: cols[6],
                            pay_id: cols[7],

                        })
                    });
                } 
            })
        }
    }, [props.openModal]);



    function approvePaycheck(event)
    {

        setDisableApprovePayButton(true);

            const customerPayAmount = parseFloat(event[0]).toFixed(2);
            const payCurrency = 'GHS';
            //const payExternalId = '';
            const payPartyId = event[1].replace(/^0+/, '');
            const payPayerMessage = event[2] + " Momo Payment";
            const payPayeeNote = "Bluefin Hotel Invoice";

            const apiuser = "0a8356fc-ce44-4436-a976-68a954d94094";
            const apikey = "9070094e5ece4fabb351a0e282043cee";
            const concatenatedString = `${apiuser}:${apikey}`;
            const base64EncodedString = window.btoa(concatenatedString);

            let xReferenceID = uuid();


            const date = new Date();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
            const day = String(date.getDate()).padStart(2, '0');
            const year = date.getFullYear();

        const requestOptions0 = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74706_initial_expense_employee_pay',
                user: acctID,
                //xCheckInRoomID: event[0][6],
                xSupplierName: event[2],
                //xCheckInLastName: event[0][8],
                xExpensePayMobileNumber: event[1],
                //xCheckInEmail: event[0][10],
                //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                //xSupportingDocumentation: selectedFile,
                //xExpenseInvoiceAttachment: expenseInvoiceAttachement,
                xPaymentType: "MTN-MOMO",
                xExpenseTotalAmount: parseFloat(event[0]).toFixed(2),
                xExpensePayDateSent: `${month}/${day}/${year}`,
                xEmployee_pay_id: event[3],
                sessionID: sessionID,
                
            }),
        }
        fetch(baseURL+'zsava_internal_indexApp', requestOptions0)
        .then(res => res.text())
        .then(data0 => {

            let cols = data0.toString().split('|');

            fetch(baseURL+'mtnapi2/disbursement/token/', {
                method: 'POST',                                                                                                                                                                                                                 
                //credentials: 'include',
                //mode: 'no-cors',
                //body: '',
                //Request headers
                headers: {
                    'authorization': 'Basic '+ base64EncodedString,
                    //'cache-Control': 'no-cache',
                    //'content-_type': 'application/json',
                    'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                    'x-target-environment': 'mtnghana',
                    'x-reference-id': xReferenceID.toString(),
                    'user': acctID,
                    'x_status': 'employee_bi_weekly_pay',
                    'x_employee_pay_id': event[3],
                    'x_customer_mobilenumber': event[1],
                    'x_invoice_id': cols[0],
                    'x_customer_invoice_id': cols[1],
                    'x_immediate_destination': acctID,
                    'x_check_in_amount': parseFloat(event[0]).toFixed(2),
                    'session_id': sessionID,
                    'momo_url': 'disbursement/v1_0/'+event[4],
                    'confirm_payment': 'confirm_or_reject',
                    // 'request_to_pay': JSON.stringify({
                    //     "amount": customerPayAmount,
                    //     "currency": payCurrency,
                    //     "externalId": xReferenceID.toString(),
                    //     "payer": {
                    //         "partyIdType": "MSISDN",
                    //         "partyId": "233"+payPartyId
                    //     },
                    //     "payerMessage": payPayerMessage,
                    //     "payeeNote": payPayeeNote
                    // }),
                    'customer_pay_amount': customerPayAmount,
                    'pay_currency': payCurrency,
                    'external_id': xReferenceID.toString(),
                    'party_id_type': 'MSISDN',
                    'party_id': payPartyId,
                    'pay_payer_message': payPayerMessage,
                    'pay_payee_note': payPayeeNote,

                },

            })
            .then(res => res.json())
            .then(res => {

                alert(res);
                alert('After Employee Pay Sent');

                const requestOptions = {
                    method: 'POST',
                    //credentials: 'include',
                    headers: {
                        'Accept': 'text/html, application/json',
                        'content-type': 'application/json',
                        //'cookie': 'cookie',
                    },
                    body: JSON.stringify({
                        Tracker: '74108_B_employee_biWeekly_pay',
                        user: acctID,
                        xCustMobileNumber: event[1],
                        xInvoiceID: cols[0],
                        xCustomerInvoiceID: cols[1],
                        xImmediateDestination: acctID,
                        xCheckInCashAmount: parseFloat(event[0]).toFixed(2),
                        sessionID: sessionID,
                        xPaymentType: 'MTN-MOMO',
                        xMomo_provider: 'MTN',
                        xMomo_financial_transaction_id: res.financialTransactionId,
                        xMomo_external_id: res.externalId,
                        xMomo_amount: res.amount,
                        xMomo_currency: 'GHS',
                        xmomo_party_id_type: res.payee.partyIdType,
                        xMomo_party_id: res.payee.partyId,
                        xMomo_payer_message: res.payerMessage,
                        xMomo_payee_note: res.payeeNote,
                        xMomo_pay_status: res.status,           
        
                    }),
                }

                fetch(baseURL+'zsava_internal_indexApp', requestOptions)
                .then(res2 => res2.text())
                .then(res2 => {
                    
                    alert(res2);
                    //addExpense('reaper');
                    alert('Employee Pay Prep finished - Pending Approval');
                    //confirmPayment_non_member([res2, event[1], event[2], cols[1], event[3], 'MTN-MOMO', 'MTN', res.financialTransactionId, res.externalId, res.amount, 'GHS', res.payee.partyIdType, res.payee.partyId, res.payerMessage, res.payeeNote, res.status]);

                })
                .catch(error => {
                    console.error(error);
                })


            })
        })
    }

    function openBroswer(event){
        //window.open(props.data.fileLocation);

        //alert( baseURL+props.data.fileLocation);

        Browser.open({ url: baseURL+event}).then(() => {});

    }

    function viewPaycheck(event)
    {

        setPayID(event[1]);
        setEmployeeName(event[2]);
        setPaySlipAttachment(event[3]);
        setShowPayslipModal(event[0]);

    }

    function closeModalHandler() {

        setViewPaychecks([]);

        props.closeModal(false);
    }


    return (
        <React.Fragment>            
            {props.openModal == true ?
                        (

                            <IonModal isOpen={ props.openModal }>
                                <IonHeader  style={{ color: "black" }}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol>
                                                <h3>{employeeName}</h3>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                </IonHeader>
                                    <IonContent className='grid_content'>
                                    <IonGrid >
                                        <IonRow >
                                                <IonCol size='3'>  Pay ID </IonCol>
                                                {/*<IonCol size='4'> Name </IonCol>*/}
                                                {/*<IonCol size='2'> Date </IonCol>*/}
                                                <IonCol size='3'> Amount </IonCol>
                                                <IonCol size='3'> Date </IonCol>                                                                             
                                                <IonCol size='3'> Action </IonCol>
                                        </IonRow>
                                    {viewPaychecks.map((detailData) =>   {
                                        return (
                                                <IonRow key={detailData.employeeID}>
                                                    <IonCol size='3'>{detailData.pay_id}</IonCol>
                                                    {/*<IonCol size='3'>{detailData.employeeName}</IonCol>*/}
                                                    {/*<IonCol size='2'>{detailData.projectTimeCreated}</IonCol>*/}
                                                    <IonCol size='3'>{detailData.stub_ammount}</IonCol>
                                                    <IonCol size='3'>{detailData.stub_date}</IonCol>
                                                    <IonCol size='3'>

                                                        {detailData.status == 'PENDING' && <IonButton className='appListButton' onClick={() => openBroswer(detailData.pay_slip)}> View </IonButton>}
                                                        {detailData.status == 'PENDING' && <IonButton className='appListButton' onClick={() => approvePaycheck([detailData.stub_ammount, detailData.momo_number, detailData.employeeName, detailData.pay_id, 'transfer'])} disabled={disableApprovePayButton}> APPROVE </IonButton>}
                                                        {/* {detailData.status == 'APPROVED' && <IonButton className='appListButton' onClick={() => viewPaycheck([true, detailData.pay_id, detailData.employeeName, detailData.pay_slip])}> View </IonButton>} */}
                                                        {detailData.status == 'APPROVED' && <IonButton className='appListButton' onClick={() => openBroswer(detailData.pay_slip)}> View </IonButton>}

                                                    </IonCol>
                                                </IonRow>
                                        )
                                    }
                                    )}
                                    </IonGrid>

                                {showPayslipModal == true && <ViewPaySlipModal openModal={ showPayslipModal } closeModal={() => setShowPayslipModal(false)} data={{
                                        fileLocation: paySlipAttachment, 
                                        payID: pay_id, 
                                        employeeName: employeeName,
                                        }}></ViewPaySlipModal>}

                                </IonContent>

                                <IonFooter className='grid_footer'>
                                    <IonButton onClick={() => closeModalHandler(false)}> Close </IonButton>
                                </IonFooter>

                            </IonModal>            
                ) : null }

            </React.Fragment>

    );
};


